import * as React from 'react';
import config from '@/server/config';
import request from '@/server/request';
const Toast = require('react-toast-mobile');

export default class Join extends React.Component<any, any> {
    private isSubmiting: boolean = false;
    public constructor(props: any) {
        super(props);
        this.state = {
            name: '',
            description: ''
        };
    }
    public render() {
        const state = this.state;
        return (
            <div>
                <ul className="apply">
                    <li>
                        <div className="apply-tit">
                            <p><b>*</b>公司名称</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入公司名称" value={state.name} onChange={e => this.inputAction('name', e)}/>
                    </li>
                    <li>
                        <div className="apply-tit">
                            <p><b>*</b>备&emsp;&emsp;注</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入您所需要备注的内容" value={state.description} onChange={e => this.inputAction('description', e)}/>
                    </li>
                </ul>
                <button className="apply-btn" disabled={!this.validatyForm()} onClick={() => this.submitAction()}>提交申请</button>
            </div>
        )
    }
    private validatyForm() {
        return this.state.name !== '' && this.state.description !== '';
    }
    /**
     * 输入处理
     * @param stateName [state对应的状态名称]
     * @parma e [输入事件]
     */
    private inputAction(stateName: string, e: any) {
        let state = {...this.state};
        state[stateName] = e.target.value
        this.setState({...state});
    }
    // 提交申请
    private async submitAction() {
        if(this.isSubmiting) return;
        if(this.state.name === '') {
            return Toast.T.notify('请填写公司名称');
        } else if(this.state.description === '') {
            return Toast.T.notify('请填写备注');
        }
        this.isSubmiting = true;
        const r = await request({
            url: `${config.API}member/auth/company/join`,
            method: 'post',
            data: {
                companyName: this.state.name,
                remark: this.state.description
            }
        });
        this.isSubmiting = false;
        if(r.code === 1) {
            this.props.history.push('/authentication/enterprise');
        } else {
            Toast.T.notify(r.message);
        }
    }  
}